<template>
  <div>
    <d-form :validated="hasErrors">
      <d-form-row class="form-group">
        <d-col cols="12">
          <label>Nome:</label>
          <d-form-input
            type="text"
            v-model="model.name"
            :state="hasErrorFiled('name')"
          />
          <d-form-invalid-feedback>Nome é obrigatório</d-form-invalid-feedback>
        </d-col>
      </d-form-row>
      <d-form-row class="form-group">
        <d-col cols="3">
          <label for="">Selecionar fonte:</label>
          <select v-model="model.settings.cryptogramFont" class="form-control">
            <option v-for="font in fonts" :key="font.value" :value="font.value">
              {{ font.label }}
            </option>
          </select>
        </d-col>
        <d-col cols="3">
          <label for="">Estilo do jogo:</label>
          <select v-model="model.settings.cryptogramTheme" class="form-control">
            <option value="default">Tema Padrão</option>
            <option value="radius">Arredondado</option>
            <option value="molotov">Molotov</option>
          </select>
        </d-col>
      </d-form-row>
      <d-form-row>
        <d-col cols="12">
          <h4 class="mb-0">
            Colunas: {{ model.columns - 1 }} x Linhas: {{ model.rows }}
          </h4>
        </d-col>
      </d-form-row>
    </d-form>
    <div class="d-flex overflow-auto">
      <div id="print" class="ml-auto">
        <div
          :class="[
            'cryptogram-theme-default mt-4 position-relative',
            {
              'cryptogram-theme-radius':
                this.model.settings.cryptogramTheme == 'radius',
              'cryptogram-theme-molotov':
                this.model.settings.cryptogramTheme == 'molotov',
            },
          ]"
          :style="{
            'grid-template-rows': `repeat(${model.rows}, ${cellSize}px)`,
            'grid-template-columns': `350px repeat(${
              model.columns - 1
            }, ${cellSize}px)`,
          }"
        >
          <cryptogram-cell
            v-for="(cell, index) in model.table"
            ref="cryptogramCell"
            :key="`${cell.text}_${index}`"
            :cell="cell"
            :data-index="index"
            :clearLine="clearLine"
            :getWordLine="getWordLine"
            :getWordByTerm="getWordByTerm"
            :font="model.settings.cryptogramFont"
            @bg-color-change="updateBgColor(index, $event)"
            @on-input="moveToNext(cell.text, index)"
          />
        </div>
        <div class="mt-2 d-flex no-print">
          <d-button
            class="btn btn-primary btn-sm text-align-center mr-2 custom_button no-print"
            @click="addRow()"
          >
            +
          </d-button>
          <d-button
            class="btn btn-danger custom_button no-print"
            @click="removeRow()"
            :disabled="model.rows < 2"
          >
            -
          </d-button>
        </div>
      </div>
      <div class="ml-2 mt-4 d-flex flex-column mr-auto no-print">
        <d-button
          class="btn btn-primary btn-sm mb-2 text-align-center custom_button"
          @click="addColumn()"
        >
          +
        </d-button>
        <d-button
          class="btn btn-danger btn-sm text-align-center custom_button"
          @click="removeColumn()"
          :disabled="model.columns < 3"
        >
          -
        </d-button>
      </div>
    </div>
    <div class="w-100 text-center my-2">
      <span>Clique duplo para trocar a cor do fundo.</span>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { cloneDeep } from '_utils';
import Events from '_utils/events';
import fonts from '_data/fonts';
import PuzzleService from '_services/rest/modules/puzzle';
import mixin from '_common/mixins/ValidateForm';
import formatErrors from '_common/mixins/FormatErrors';
import PuzzleTable from '_common/mixins/PuzzleTable';
import CryptogramCell from './CryptogramCell.vue';
import {
  _CRYPTOGRAM_CLEAR_QUESTION_,
  _CRYPTOGRAM_CLEAR_ALL_ANSWERS_,
  _CRYPTOGRAM_FILL_ALL_LINES_,
  _CRYPTOGRAM_SET_ANSWER_,
  _CRYPTOGRAM_SET_QUESTION_,
  _LOAD_MODEL_,
  CELL,
  CELL_SIZE,
  DEFAULT_SETTINGS,
  MODEL,
} from './CryptogramModel';

export default {
  name: 'cryptogram-form',
  mixins: [mixin, formatErrors, PuzzleTable],
  components: {
    CryptogramCell,
  },
  computed: {
    cellSize() {
      return CELL_SIZE;
    },
  },
  data() {
    return {
      model: cloneDeep(MODEL),
      fonts,
      errors: {
        name: { required: false },
      },
    };
  },
  methods: {
    ...mapActions(['activeAlert', 'setToggle']),
    drawTable() {
      this.model.table = [];
      for (let row = 0; row < this.model.rows; row += 1) {
        for (let column = 0; column < this.model.columns; column += 1) {
          this.addNewCell(this.model.table, row, column);
        }
      }
    },
    addNewCell(table, row, column) {
      table.push({
        ...cloneDeep(CELL),
        ...{
          positionx: row.toString(),
          positiony: column.toString(),
          isAnswer: column !== 0,
        },
      });
    },
    addColumn() {
      this.model.columns = this.model.columns + 1;
      this.updateTable();
    },
    removeColumn() {
      this.model.columns = this.model.columns - 1;
      this.updateTable();
    },
    addRow() {
      this.model.rows = this.model.rows + 1;
      this.updateTable();
    },
    removeRow() {
      this.model.rows = this.model.rows - 1;
      this.updateTable();
    },
    updateTable() {
      const newArray = [];
      for (let row = 0; row < this.model.rows; row += 1) {
        for (let column = 0; column < this.model.columns; column += 1) {
          const existingItem = this.model.table.find(item =>
            item.positionx === row.toString() &&
              item.positiony === column.toString());
          if (existingItem) {
            newArray.push(existingItem);
          } else {
            this.addNewCell(newArray, row, column);
          }
        }
      }
      this.model.table = newArray;
    },
    updateBgColor(index, state) {
      this.model.table[index].settings.locked = state;
    },
    moveToNext(value, index) {
      const nextIndex = value.trim() === '' ? index - 1 : index + 1;
      const cell = this.$refs.cryptogramCell[nextIndex];
      if (cell) {
        cell.focusInput();
      }
    },
    getWordLine(line) {
      let word = '';
      const wordCallback = index => {
        if (this.model.table[index].positiony !== '0') {
          if (this.model.table[index].text) {
            word += this.model.table[index].text;
          } else word += '_';
        }
      };
      this.loopTableRow(line, wordCallback);
      return word;
    },
    setWordLine(cell) {
      const { line, answer, question } = cell;
      let count = 0;
      const wordCallback = index => {
        const item = this.model.table[index];
        if (item.positiony === '0') {
          item.text = question?.question || null;
          item.question_id = question?.id || null;
          item.answer_id = cell?.id || null;
        } else {
          item.text = answer[count].toUpperCase();
          count += 1;
        }
      };
      this.loopTableRow(line, wordCallback);
      this.activeAlert({
        message: 'Palavra completada com sucesso!',
        theme: 'success',
      });
    },
    clearLine(line) {
      Events.$emit(_CRYPTOGRAM_CLEAR_QUESTION_, line);
      const deleteLineCallback = index => {
        if (!this.model.table[index].settings.locked) {
          this.model.table[index].text = '';
        }
      };
      this.loopTableRow(line, deleteLineCallback);
    },
    cleanAllLines() {
      this.model.table.forEach(item => {
        if (item.positiony === '0') {
          Events.$emit(_CRYPTOGRAM_CLEAR_QUESTION_, item.positionx);
        }
        if (!item.settings.locked) item.text = '';
      });

      this.activeAlert({ message: 'Criptograma limpo!', theme: 'success' });
    },
    save() {
      if (this.checkForm()) {
        const table = this.model.id
          ? this.model.table.map(item => ({
            ...item,
            updated: true,
          }))
          : this.model.table;
        const puzzle = {
          ...this.model,
          table,
          slug: `${this.model.name.replace(' ', '-')}-criptograma`,
        };
        PuzzleService.save(puzzle)
          .then(response => {
            this.activeAlert({ message: response.message, theme: 'success' });
            if (this.$route.name === 'admin-cryptogram-new') {
              this.$router.push({
                name: 'admin-cryptogram-edit',
                params: { puzzleId: response.id },
              });
            }
            this.model = response;
          })
          .catch(error => {
            const errors = this.formatErrors(error.data);
            this.activeAlert({ message: errors, theme: 'danger' });
          });
      }
    },
    getWordByTerm(line) {
      this.setToggle({ type: 'progress', bool: true });
      const word = this.getWordLine(line);
      PuzzleService.getWordByTerm(word)
        .then(response => {
          if (response.answer) {
            Events.$emit(_CRYPTOGRAM_SET_ANSWER_, {
              ...response,
              line,
            });
            Events.$emit(_CRYPTOGRAM_SET_QUESTION_, {
              ...response,
              line,
            });
          } else {
            this.activeAlert({
              message: 'Nenhuma palavra encontrada!',
              theme: 'danger',
            });
          }
        })
        .catch(error =>
          this.activeAlert({ message: error.message, theme: 'danger' }))
        .finally(() => this.setToggle({ type: 'progress', bool: false }));
    },
    fillCryptogram() {
      let row = 0;
      while (row < this.model.rows) {
        this.getWordByTerm(row);
        row += 1;
      }
    },
  },
  mounted() {
    this.drawTable();
    Events.$on(_CRYPTOGRAM_SET_ANSWER_, word => {
      if (word) this.setWordLine(word);
    });
    Events.$on(_LOAD_MODEL_, model => {
      const settings = model.settings || { ...DEFAULT_SETTINGS };
      this.model = {
        ...model,
        settings,
      };
    });
    Events.$on(_CRYPTOGRAM_CLEAR_ALL_ANSWERS_, () => {
      this.cleanAllLines();
    });
    Events.$on(_CRYPTOGRAM_FILL_ALL_LINES_, () => {
      this.fillCryptogram();
    });
  },
  destroyed() {
    Events.$off(_CRYPTOGRAM_SET_ANSWER_);
    Events.$off(_CRYPTOGRAM_CLEAR_ALL_ANSWERS_);
    Events.$off(_CRYPTOGRAM_FILL_ALL_LINES_);
    Events.$off(_LOAD_MODEL_);
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/cryptogram';
</style>
